import ChevronRightIcon from "assets/icon/ChevronRightIcon";
import { PagesTitle } from "components/Cards";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Setting(){
    let navigate = useNavigate()
    
    const [isAdmin, setIsAdmin] = useState(localStorage.getItem('IsAdmin'))

    return(
        <div className="flex flex-col gap-2 p-2 sm:p-6">
            <PagesTitle title='Settings' />
            
            <div className="bg-white p-4 rounded-xl shadow-sm border">
                { isAdmin === "1" && (
                    <div>
                        <div className="">
                            <span className="font-semibold text-lg">User Setting</span>
                        </div>
                        <hr />
                        <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/user")}}>
                            <span className="">User</span>
                            <ChevronRightIcon className="fill-black w-6" />
                        </button>
                        <hr />
                    </div>
                )}
                
                <div className="mt-4">
                    <span className="font-semibold text-lg">General Setting</span>
                </div>
                <hr />
                <button className="px-4 py-4  w-full text-left flex justify-between hover:bg-slate-100 transition-all" onClick={() => {navigate("/setting/tax")}}>
                    <span className="">Tax</span>
                    <ChevronRightIcon className="fill-black w-6" />
                </button>
                <hr />
            </div>
        </div>
    )
}